// extracted by mini-css-extract-plugin
export var errorIcon = "_nt-1";
export var nameLogo = "_nt-0";